import React, { useState } from 'react';
import './CommentaireForm.css';
import Button from '../Button/Button';

interface CommentaireFormProps {
  onSubmit: (message: string) => void;
}

const CommentaireForm: React.FC<CommentaireFormProps> = ({ onSubmit }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSubmit(message);
      setMessage('');
    }
  };

  return (
    <form className="commentaire-form" onSubmit={handleSubmit}>
      {/* Titre retire : l'intitule est deja porte par le placeholder du champ. */}
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Ajouter un mémo interne visible uniquement par les membres de votre compte"
        rows={4}
      />
      <Button
        value="Ajouter"
        type="submit"
        variant="secondary"
        size="small"
        disabled={!message.trim()}
      >
      </Button>
    </form>
  );
};

export default CommentaireForm;